import { api, resolvePagination } from './api';

/**
 * Retrieve patient plans.
 * @param {string} uuid - The UUID of the patient.
 */
export const getPatientPlans = async (uuid) => {
    const response = await api.post('/cheart/patient/plans', { uuid });
    return response.data;
};

/**
 * Retrieve patient questionnaire answers.
 * @param {string} uuid - The UUID of the patient.
 * @param {number} pageLimit - The maximum number of questionnaire answers to retrieve per page.
 * @param {string} pageToken - The token for the next page of results.
 */
export const getPatientQuestionnaireAnswers = async (uuid, pageLimit, pageToken) => {
    const headers = resolvePagination(pageToken, pageLimit);
    return api.post('/cheart/answers', { patient: uuid }, { headers });
};

/**
 * Retrieve patient pending questionnaire.
 * @param {string} uuid - The UUID of the patient.
 * @param {number} pageLimit - The maximum number of questionnaire answers to retrieve per page.
 * @param {string} pageToken - The token for the next page of results.
 */
export const getPatientPendingAnswers = async (uuid, pageLimit, pageToken) => {
    const headers = resolvePagination(pageToken, pageLimit);
    const body = {
        patient: uuid
    };
    return api.post('/cheart/answers/pending', body, { headers });
};
